import { ICityPendingInvoiceFile } from '../../../interfaces';

class CityPendingInvoiceFileMapper {

    toPersistence(domainCitInvoiceFile: ICityPendingInvoiceFile): any {
        return {
            id: domainCitInvoiceFile.id,
            file_name: domainCitInvoiceFile.file_name,
            import_progress: domainCitInvoiceFile.import_progress,
            status: domainCitInvoiceFile.status,
            created_at: domainCitInvoiceFile.created_at,
            updated_at: domainCitInvoiceFile.updated_at,
        }
    }

    toDomain(persistenceCityPendingInvoiceFile: any): ICityPendingInvoiceFile {
        return {
            id: persistenceCityPendingInvoiceFile.id,
            file_name: persistenceCityPendingInvoiceFile.file_name,
            import_progress: persistenceCityPendingInvoiceFile.import_progress,
            status: persistenceCityPendingInvoiceFile.status,
            file: persistenceCityPendingInvoiceFile.file,
            created_at: persistenceCityPendingInvoiceFile.created_at,
            updated_at: persistenceCityPendingInvoiceFile.updated_at,
        }
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new CityPendingInvoiceFileMapper();
